import React from 'react';
import _ from 'lodash';
import { isLiveScorer, getOwnLive, extract } from '../../../helpers';
import Card from './match/card/Card';
import PropTypes from 'prop-types';
import './ListMatch.css';

const ListMatch = props => {
    const own = _.filter(props.list, match => !_.isEmpty(getOwnLive(match.lives)));
    const orderedMatch = _.orderBy(own, a => a.lives.length > 0 && isLiveScorer(a.lives) ? extract(_.orderBy(a.lives, ['@id'], 'desc')[0]['@id'], '/', 3) : '-1', 'desc');
    const other = _.filter(props.list, match => _.isEmpty(getOwnLive(match.lives)));
    const matches = props.page === 'upcomingMatch' ? _.concat(orderedMatch, other) : props.list;

    return (
        <div className='ls_list_match' style={{marginBottom: '50px'}}>
            {
                _.map(matches, m => <Card key={m.maNo} {...m} page={props.page} />)
            }
        </div>
    )
}

ListMatch.propTypes = {
    list: PropTypes.oneOfType([PropTypes.object, PropTypes.array]).isRequired,
    page: PropTypes.string.isRequired
}

export default ListMatch;